import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { PasswordControl } from '../../../models/controls/password-control';
import { OrderService } from '../../../services/order/order.service';
import { PasswordConfirmControlComponent } from '../password-confirm-control/password-confirm-control.component';
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-password-control',
  templateUrl: './password-control.component.html',
  styleUrls: ['./password-control.component.scss'],
})
export class PasswordControlComponent
  extends BaseControlComponent<PasswordControl>
  implements OnInit, AfterViewInit {
  @Input()
  confirm?: PasswordConfirmControlComponent;

  constructor(
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    super.setValidators();
    this.setPasswordValidators();
    this.ngModel?.control.setValidators(this.validators);
  }

  protected setPasswordValidators(): void {
    if (this.control.min) {
      this.validators.push(Validators.minLength(this.control.min));
    }
    if (this.confirm) {
      this.validators.push((control: AbstractControl) =>
        this.isSame(control, this.confirm as PasswordConfirmControlComponent)
      );
    }
  }

  protected isSame(
    control: AbstractControl,
    parent: PasswordControlComponent
  ): ValidationErrors | null {
    const isSame = control.value === parent?.ngModel?.value;
    if (isSame && parent?.ngModel?.control.errors?.mustMatch) {
      delete parent?.ngModel?.control.errors.mustMatch;
      if (Object.keys(parent?.ngModel?.control.errors).length === 0) {
        parent?.ngModel?.control.setErrors(null);
      }
    }
    return isSame ? null : { mustMatch: true };
  }
}
